import { Link as LinkLi } from '@material-ui/core';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import React, { lazy, useState } from 'react';
import { Link } from 'react-router-dom';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`);
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const FuelComsumptionAddEdit = lazy(() => import(`@/modules/FuelComsumptionAddEdit`));

const TopActions = ({
  Styled,
  fuelConsumption,
  i18n,
  filterSuccess,
  filters,
  setPagination,
  callback,
  vehicleList,
  driverList,
  getVehicleListDropDown,
  getDrivers,
  getStateListData,
  addEditFuelData,
}) => {
  const selectChange = (e) => {
    filterSuccess(e);
    setPagination(true);
  };

  const [open, setOpen] = useState(false);
  const [withCloseIcon, setwithCloseIcon] = useState(true);
  const [backgroundModal, setbackgroundModal] = useState(false);
  const closeModal = (event) => {
    setOpen(false);
  };
  const clickedModal = (e) => {
    setOpen(true);
  };

  const modalDataHandler = () => {
    getVehicleListDropDown({ apiId: 'getVehicleListDropDown' });
    getDrivers({ apiId: 'getDrivers' });
    getStateListData({ apiId: 'getStateListData' });
  };

  return (
    <>
      {layout !== 'OldUi' && <Breadcrumb filters={filters} />}
      <Styled.TopWrapper>
        <Styled.SearchWrapper>
          <Search
            id={'clearSearch'}
            onChange={(e) => selectChange(e)}
            default={fuelConsumption?.list}
            fromData
            placeHolder={i18n.t('fuelConsumption.search')}
            query={['drivers', 'vehicleName']}
            id="fuel_consumption"
          ></Search>
        </Styled.SearchWrapper>
        <Styled.IconWrapper>
          <LinkLi
            className="userNew"
            onClick={() => {
              modalDataHandler();
              setbackgroundModal(false);
              setwithCloseIcon(true);
              clickedModal();
            }}
          >
            <Icon src={mediaUrls?.addVehicle} primary />
          </LinkLi>
          <LinkLi component={Link} to={pageUrls.addUser} className="addUserButtonhover userOld">
            <Button variant="body2" className="linkStyle addUser" label={i18n.t('users.addNewUser')}></Button>
          </LinkLi>
        </Styled.IconWrapper>
        <div className="breadcrumbClass">{layout === 'OldUi' && <Breadcrumb filters={filters} />}</div>
      </Styled.TopWrapper>
      {driverList?.length > 0 && vehicleList?.length > 0 && fuelConsumption?.stateListData && (
        <Modal.default
          open={open}
          width="700px"
          setOpen={setOpen}
          data={{
            header: '',
            content: () => {
              return (
                <FuelComsumptionAddEdit
                  saveDocument={addEditFuelData}
                  uploadApi={'fuelAddEditApi'}
                  stateListData={fuelConsumption?.stateListData}
                  driverList={driverList}
                  vehicleList={vehicleList}
                  closeModal={closeModal}
                  callback={callback}
                  parent="FuelComsumptionReport"
                />
              );
            },
          }}
          onCloseModal={closeModal}
          background="black"
          withCloseIcon={withCloseIcon}
          backgroundModal={backgroundModal}
          deletePopup
        />
      )}
    </>
  );
};
export default TopActions;
